module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_retrobound_1.c62d2ff2.jpg";